import { createContext } from 'react';

import { type InternalFieldRegistrationContextValue } from './types';

const InternalFieldRegistrationContext =
  createContext<InternalFieldRegistrationContextValue | null>(null);

export default InternalFieldRegistrationContext;
